export const ICON_NAME_ATTRIBUTE = 'name';
export const ICON_BRAND_ATTRIBUTE = 'brand';

export const ENCORE_ICON_NAME_ATTRIBUTE = 'encore-name';
export const ENCORE_ICON_CLASS_ATTRIBUTE = 'encore-class';
export const ENCORE_ICON_COLOR_ATTRIBUTE = 'encore-color';
export const ENCORE_ICON_SIZE_ATTRIBUTE = 'encore-size';
